import React, { useState } from 'react';
import ChatButton from './ChatButton';
import ChatbotWidget from './ChatbotWidget';

const ChatWrapper = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => setIsChatOpen(!isChatOpen);

  return (
    <>
      <ChatButton onClick={toggleChat} isOpen={isChatOpen} />
      <ChatbotWidget isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </>
  );
};

export default ChatWrapper; 